import React from "react";
import ArticlePage from "../ArticlePage";

const FashionRoundup = () => (
  <ArticlePage
    title="Fashion Roundup"
    subtitle="Fashion"
    leadImage="/img/culture/fashion.webp"
    body={[
      "A short guide to four houses shaping the current conversation \u2014 from streetwear staples to conceptual couture. Tap any of the boxes below to jump into the brand's own press or news feed.",
    ]}
    sources={[
      {
        brand: "Supreme",
        title: "Latest news, drops, and lookbooks",
        host: "supreme.com/news",
        href: "https://www.supreme.com/news",
        accent: "#e2333a",
      },
      {
        brand: "Vogue",
        title: "Runway reviews, editorials, industry coverage",
        host: "vogue.com",
        href: "https://www.vogue.com",
        accent: "#111111",
      },
      {
        brand: "Maison Margiela",
        title: "Collections, artisanal shows, brand universe",
        host: "maisonmargiela.com",
        href: "https://www.maisonmargiela.com",
        accent: "#c4b998",
      },
      {
        brand: "Rick Owens",
        title: "Runway, drops, and studio dispatches",
        host: "rickowens.eu",
        href: "https://www.rickowens.eu",
        accent: "#5a5044",
      },
    ]}
  />
);

export default FashionRoundup;
